import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function Loader({ width }) {
  return (
    <div className="loader">
      <div className="loader__fill" style={{ width }} />
    </div>
  );
}

Loader.defaultProps = {
  width: '0%',
};

Loader.propTypes = {
  width: PropTypes.string,
};
